import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { UserService } from "../../../service/user.service";
import { UsersChangesReportFilter } from '../../../persistence/dto/assign-changes-report-filter';
import { CampaignService } from '../../../core/services/campaign.service';
import { CampaignDTO } from '../../../core/models/campaignDTO.model';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";


@Component({
    selector: 'kt-dialog-user-level-changes',
    templateUrl: './dialog-user-level-changes.component.html',
    styleUrls: ['./dialog-user-level-changes.component.scss'],
})
export class DialogUserLevelChangesComponent implements OnInit {

    campaignsFrom: CampaignDTO[] = [];
    campaignsTo: CampaignDTO[] = [];
    campaignsReportForm: FormGroup;
    isLoadingResults: boolean = false;


    constructor(
        public dialogRef: MatDialogRef<DialogUserLevelChangesComponent>,
        private fb: FormBuilder,
        private cdr: ChangeDetectorRef,
        private userService: UserService,
        private campaignService: CampaignService,
      ) { }


    ngOnInit(): void {

        this.campaignsReportForm = this.fb.group({
            campaignFrom: ['', Validators.required],
            campaignTo: ['', Validators.required]
          });
        this.initForm();
    }


    initForm(){
        this.loadCampaigns();
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    loadCampaigns(){
        this.campaignService.getCampaigns().subscribe(
            campaigns => {
              if (campaigns && campaigns.length > 0) {
                this.campaignsFrom = campaigns;
                this.campaignsTo = campaigns;
                //this.campaignsReportForm.controls['campaignsTo'].setValue(0);
                //this.campaignsReportForm.controls['campaignsFrom'].setValue(0);
              }
              this.cdr.detectChanges();
            },
            error => {
              this.cdr.detectChanges();
            }
          );
    }

    isControlHasError(controlName: string, validationType: string): boolean {
      const control = this.campaignsReportForm.controls[controlName];
      if (!control) {
          return false;
      }

      return control.hasError(validationType) && (control.dirty || control.touched);
  }

    exportCambiosUsuarios(){
        this.isLoadingResults = true;
        this.cdr.detectChanges();
        const controls = this.campaignsReportForm.controls;
        if (this.campaignsReportForm.invalid) {
            Object.keys(controls).forEach(controlName => {
                    controls[controlName].markAsTouched();
                }
            );
            return;
        }

        let data = this.campaignsReportForm.value;

        console.log(data);

        if(this.campaignsReportForm.controls['campaignTo'].value <= this.campaignsReportForm.controls['campaignFrom'].value)
        {
          this.isLoadingResults = false; 
          this.cdr.detectChanges();
          window.alert("La campaña 'desde' elegida no puede ser posterior a la de 'hasta'");
        }
        else
        {
          this.exportExcel(this.userService.downloadUsersAssignChanges(data), "CambiosAsignacionUsuarios.xlsx");  

        }
    }

    exportExcel(request, filename) {
        request.subscribe(x => { saveAs(x, filename), this.isLoadingResults = false; this.cdr.detectChanges(); },
            error => { alert('Error al descargar el archivo'), this.isLoadingResults = false;  this.cdr.detectChanges(); });
    }

}